module.exports = __webpack_public_path__ + "img/icon52.97f86e09.png";